import { useContext, useState, useEffect } from 'react';
import { ImagesContext } from '../contexts/ImagesContext';

export function useGetBase64Image(url: string) {
  const { exchangeForUrl } = useContext(ImagesContext);
  const [base64Image, setBase64Image] = useState('');

  const isBase64Data = (url: string) => {
    const regex = /^data:image\/(png|gif|jpg|jpeg|webp);base64,/;
    return regex.test(url);
  };

  useEffect(() => {
    if (!url) {
      return;
    }
    if (isBase64Data(url)) {
      setBase64Image(url);
      return;
    }
    exchangeForUrl(url).then((url: string) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = () => {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (typeof reader.result !== 'string') {
            return;
          }
          setBase64Image(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }, [exchangeForUrl, url]);

  return base64Image;
}
